module.exports = __webpack_public_path__ + "img/Tessellate46.c951ca19.jpg";